import React from 'react';

import SingleMsgPrompt from './common/SingleMsgPrompt';

const PersonalisationInput = ({
  item,
  handleAddMessage,
  selection,
  firstMsg,
  singleMessage,
  handleSingleMessage,
  setPresetMsg,
  presetMsg,
  setSingleMessage,
  isMobile,
  getCharacterCount,
  setFocusedProduct,
  focusedProduct,
}) => {
  const handleInput = (e, bundleItemId) => {
    presetMsg ? setPresetMsg('') : null;

    if (focusedProduct) {
      if (singleMessage && focusedProduct.bId === bundleItemId) {
        handleSingleMessage(e.target.value);
      } else if (!singleMessage) {
        handleAddMessage(e.target.value, bundleItemId);
      }
    } else {
      if (singleMessage && firstMsg === bundleItemId) {
        handleSingleMessage(e.target.value);
      } else if (singleMessage && firstMsg !== bundleItemId) {
        setSingleMessage(false);
        handleAddMessage(e.target.value, bundleItemId);
      } else if (!singleMessage) {
        handleAddMessage(e.target.value, bundleItemId);
      }
    }
  };

  const handleFocus = (i) => {
    setFocusedProduct(i);
  };

  return !isMobile ? (
    <>
      <input
        onChange={(e) => handleInput(e, item.bId)}
        onFocus={() => handleFocus(item)}
        value={item?.message ? item.message : ''}
        disabled={item.personalisation_available === 'N' ? true : null}
        placeholder={
          item.personalisation_available === 'Y'
            ? 'Your message'
            : 'Unavailable'
        }
      />
    </>
  ) : (
    <>
      <input
        onChange={(e) => handleInput(e, item.bId)}
        value={item?.message ? item.message : ''}
        disabled={item.personalisation_available === 'N' ? true : null}
        placeholder={`Your message`}
      />

      {item.personalisation_available === 'Y' && (
        <span>({getCharacterCount(item)})</span>
      )}
    </>
  );
};

export default PersonalisationInput;
